// Lightweight i18n: flat dictionary keyed by language. Use t(key) helper.
// For lists / structured content, store arrays/objects directly under the key.

const de = {
  // Nav
  "nav.home": "Start",
  "nav.services": "Leistungen",
  "nav.projects": "Projekte",
  "nav.about": "Über uns",
  "nav.contact": "Kontakt",
  "nav.partner_budova": "Partner Budova",
  "nav.cta": "Beratung anfragen",
  "nav.login": "Anmelden",
  "nav.account": "Mein Konto",
  "konto.unauth": "Bitte melden Sie sich an, um Ihr Konto zu sehen.",
  "konto.logout": "Abmelden",
  "konto.welcome": "Willkommen zurück",

  "konto.favorites_title": "Gemerkte Projekte",
  "konto.favorites_empty": "Noch keine Projekte gemerkt.",
  "konto.inquiries_title": "Meine Anfragen",
  "konto.inquiries_empty": "Noch keine Anfragen gesendet.",


  // Common
  "common.back_to_overview": "Zurück zur Übersicht",
  "common.read_more": "Mehr erfahren",
  "common.view_all": "Alle ansehen",
  "common.scroll_explore": "Scroll · Entdecken",
  "common.send": "Anfrage senden",
  "common.submitting": "Wird gesendet…",
  "common.required_short": "Pflicht",
  "common.protected_area": "Geschützter Bereich · Nur autorisierter Zugriff",
  "common.choose": "Bitte wählen",
  "common.years_experience": "Jahre Erfahrung",
  "common.projects_realised": "Realisierte Projekte",
  "common.sqm_built": "m² gebaut",
  "common.sqm_managed": "m² in Verwaltung",
  "common.address": "Adresse",
  "common.email": "E-Mail",
  "common.phone": "Telefon",
  "common.opening_hours": "Öffnungszeiten",
  "common.imprint": "Impressum",
  "common.privacy": "Datenschutz",
  "common.admin": "Admin",
  "common.all_rights": "Alle Rechte vorbehalten.",
  "common.partner": "Technologie-Partner",

  // Home
  "home.eyebrow": "Royalhouse Bauträger GmbH · Wien",
  "home.hero.title.l1": "Wo modernes",
  "home.hero.title.l2_pre": "",
  "home.hero.title.l2_em": "Wohnen",
  "home.hero.title.l2_post": "auf",
  "home.hero.title.l3_pre": "zeitloses",
  "home.hero.title.l3_em": "Design",
  "home.hero.title.l4": "trifft.",
  "home.hero.lede":
    "Von der ersten Idee über BIM-Planung und serielle Vorfertigung bis zu Bau, Installation und Betrieb — wir liefern Gebäude durchgängig digital geplant, vorgefertigt und rückverfolgbar.",
  "home.hero.cta_primary": "Projekte ansehen",
  "home.hero.cta_secondary": "Beratung anfragen",

  "home.intro.eyebrow": "01 · Philosophie",
  "home.intro.title": "Bauen als durchgängiges Ökosystem.",
  "home.intro.body":
    "In 30 Jahren haben wir über 60 Projekte mit rund 1.000.000 m² realisiert und verwalten aktuell mehr als 750.000 m² Wohnfläche. Alle Prozesse steuern wir im Budova-Ökosystem mit einem BIM-basierten ERP-System — transparent, präzise und nachhaltig.",
  "home.intro.body2":
    "Unser Anspruch: hochwertige Eigentumswohnungen in Wien schneller, präziser und transparenter zu liefern als der Markt — mit serieller Vorfertigung und industrieller Qualitätssicherung.",
  "home.intro.cta": "Mehr über uns",

  "home.e2e.eyebrow": "02 · End-to-End Bausystem",
  "home.e2e.title.l1": "Digital geplant.",
  "home.e2e.title.l2": "Industriell gefertigt.",
  "home.e2e.title.l3": "Rückverfolgbar gebaut.",
  "home.e2e.cta": "Alle Leistungen",

  "home.projects.eyebrow": "03 · Projekte",
  "home.projects.title.l1": "Aktuelle",
  "home.projects.title.l2": "Highlights",
  "home.projects.cta": "Alle Projekte",
  "home.prod.eyebrow": "Eigene Produktion",
  "home.prod.title": "Alles aus Beton. A+++.",
  "home.prod.body": "Wir bauen mit eigener, industrieller Fertigteil-Produktion — BIM-Planung, GRC-Fertigteile, Montage und Fertigstellung aus einer Hand. Erdbebensicher bis Magnitude 9,5, energieeffizient in Klasse A+++.",
  "home.prod.cta": "Produktion ansehen",
  "home.prod.fact1": "Produktionsfläche",
  "home.prod.fact2": "Erdbebensicher",
  "home.prod.fact3": "Energieklasse",

  "home.cta.eyebrow": "04 · Anfrage",
  "home.cta.title.l1": "Sichern Sie sich",
  "home.cta.title.l2": "Ihren",
  "home.cta.title.l2_em": "well-being",
  "home.cta.title.l3": "Lebensstil.",
  "home.cta.lede": "Begrenzte Anzahl — jetzt vormerken & Wunschwohnung sichern.",
  "home.cta.btn": "Termin vereinbaren",

  // Services
  "services.eyebrow": "Leistungen",
  "services.title.l1": "End-to-End",
  "services.title.l2": "Bausystem.",
  "services.lede":
    "Wir liefern Gebäude durchgängig digital geplant, vorgefertigt und rückverfolgbar — von der ersten Modellierung bis zur Übergabe. Kern ist eine BIM-basierte Prozesskette plus industrielle Vorfertigung mit eindeutiger Kennzeichnung jedes Bauteils.",
  "services.timeline.eyebrow": "Zeitplan · Beispiel",
  "services.timeline.title.l1": "Neubau",
  "services.timeline.title.l2": "6.000 m² BGF",
  "services.timeline.title.l3": "in 23 Wochen.",
  "services.timeline.lede":
    "Vom Modell zur Übergabe: ein Beispiel-Taktplan unseres E2E-Systems — vom BIM-Workflow über die Werksvorfertigung bis zur Inbetriebnahme.",
  "services.apartments.eyebrow": "Wohnungsgrundrisse",
  "services.apartments.title.l1": "Maßgeschneiderte",
  "services.apartments.title.l2": "Grundrisse für jeden",
  "services.apartments.title.l3": "Lebensstil.",
  "services.equipment.eyebrow": "Leistungen & Ausstattung",
  "services.equipment.title.l1": "Alles, was den",
  "services.equipment.title.l2": "Alltag leichter macht.",
  "services.cta_projects": "Projekte ansehen",
  "services.cta_contact": "Beratung anfragen",

  // Projects
  "projects.eyebrow": "Projekte",
  "projects.title.l1": "Wohnen mit",
  "projects.title.l2": "Charakter.",
  "projects.lede":
    "60+ realisierte Projekte. ~1.000.000 m² gebaute Fläche. Aktuell in Verwaltung: über 750.000 m². Eine Auswahl aktueller und vergangener Vorhaben.",
  "projects.filter.category": "Kategorie:",
  "projects.filter.status": "Status:",
  "projects.filter.all": "Alle",
  "projects.filter.villa": "Villen",
  "projects.filter.einfamilienhaus": "Einfamilienhäuser",
  "projects.filter.reihenhaus": "Reihenhäuser",
  "projects.filter.stadthaus": "Stadthäuser",
  "projects.filter.wohnbau": "Wohnbau",
  "projects.filter.sanierung": "Sanierung",
  "projects.filter.infrastruktur": "Infrastruktur",
  "projects.empty": "Keine Projekte gefunden.",
  "projects.loading": "Lade Projekte…",
  "projects.card.details": "Details ansehen",
  "projects.card.energy_class": "A+++ Energieklasse",
  "projects.card.certified": "geprüft nach ÖNORM · klimaaktiv",

  // Project detail
  "project.about_eyebrow": "Über das Projekt",
  "project.video_eyebrow": "Projektvideo",
  "project.video_title": "Standort im Bild.",
  "project.video_lede": "Ein cinematic Überblick über Lage, Architektur und Quartier — gedreht vor Ort.",
  "project.about_title": "Architektur & Konzept",
  "project.highlights": "Highlights",
  "project.floorplans": "Grundrisse",
  "project.energy_certificate": "Energieausweis",
  "project.energy_certificate_download": "Energieausweis herunterladen",
  "chat.button_label": "Fragen stellen",
  "chat.title": "Royal House Assistent",
  "chat.subtitle": "Fragen zu unseren Projekten",
  "chat.placeholder": "Ihre Frage…",
  "chat.send": "Senden",
  "chat.greeting": "Guten Tag! Ich beantworte gerne Fragen zu unseren Projekten in Wien, der Steiermark, Salzburg und der Ukraine. Wie kann ich helfen?",
  "chat.error": "Der Assistent ist derzeit nicht erreichbar. Bitte versuchen Sie es später erneut oder nutzen Sie das Kontaktformular.",
  "chat.close": "Schließen",
  "chat.thinking": "Antwortet…",
  "chat.suggestion_1": "Welche Projekte gibt es in Wien?",
  "chat.suggestion_2": "Wie kann ich Sie kontaktieren?",
  "chat.suggestion_3": "Was macht Royal House besonders?",



  "project.specs": "Eckdaten",
  "project.cta_inquire": "Anfrage senden",
  "project.not_found": "Projekt nicht gefunden.",

  // About
  "about.eyebrow": "Über uns",
  "about.title.l1": "Exzellenz, der",
  "about.title.l2": "Sie",
  "about.title.l2_em": "vertrauen.",
  "about.lede":
    "Royal House Bauträger GmbH mit Sitz in Wien entwickelt, plant und realisiert Wohnprojekte im gehobenen Segment. Wir verbinden klassische Bauträgerexpertise mit moderner BIM-Planung, präziser Vorfertigung und einem internationalen Partnernetzwerk. Die technische Gebäudeausrüstung verantwortet unser Haustechnik-Partner ECO Building Technik.",
  "about.values.eyebrow": "Unsere Werte",
  "about.team.eyebrow": "Geschäftsleitung Partner",
  "about.team.title.l1": "Menschen, die Verantwortung",
  "about.team.title.l2": "übernehmen.",
  "about.architects.eyebrow": "Top-Architekten · Kooperations-Allianz",
  "about.architects.title.l1": "Internationale Top-Architekten",
  "about.architects.title.l2": "in unserer Allianz.",
  "about.partners.eyebrow": "Partner Unternehmen",
  "about.partners.title": "Unser Netzwerk.",
  "about.cta.title.l1": "Lassen Sie uns",
  "about.cta.title.l2": "gemeinsam",
  "about.cta.title.l2_em": "bauen.",

  // Contact
  "contact.eyebrow": "Kontakt",
  "contact.title.l1": "Sprechen wir",
  "contact.title.l2": "über Ihr",
  "contact.title.l2_em": "Zuhause.",
  "contact.lede":
    "Termin buchen oder mehr Infos erhalten — unser Vertrieb meldet sich innerhalb von 24 Stunden bei Ihnen.",
  "contact.form.eyebrow": "Anfrage senden",
  "contact.form.title": "Termin vereinbaren",
  "contact.wellbeing.eyebrow": "Gesund wohnen · Technologie-Partner",
  "contact.wellbeing.title": "Well-Being ConTech.",
  "contact.wellbeing.body": "Gesundes, energieeffizientes Wohnen fließt direkt in unsere Projekte ein — von schadstoffarmen Materialien bis zur Smart-Home-Steuerung.",
  "contact.wellbeing.cta_partner": "Zur Partnerseite",
  "contact.wellbeing.cta_external": "wellbeingcontech.com",
  "contact.form.first_name": "Vorname *",
  "contact.form.last_name": "Nachname *",
  "contact.form.email": "E-Mail *",
  "contact.form.phone": "Telefon",
  "contact.form.residence_size": "Wohnungsgröße",
  "contact.form.price_range": "Preisbereich",
  "contact.form.message": "Nachricht",
  "contact.form.message_placeholder": "Ihre Wünsche, Fragen oder Wunschtermin",
  "contact.form.privacy_note":
    "Mit dem Absenden stimmen Sie unserer Datenschutzerklärung zu. Ihre Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage verwendet.",
  "contact.success.title": "Vielen Dank!",
  "contact.success.body":
    "Ihre Anfrage ist eingegangen. Unser Vertrieb meldet sich innerhalb von 24 Stunden.",
  "contact.success.new": "Neue Anfrage stellen →",
  "contact.error.required": "Bitte Vor-, Nachname und E-Mail ausfüllen.",
  "contact.error.generic": "Anfrage konnte nicht gesendet werden.",
  "contact.success.toast": "Vielen Dank! Wir melden uns in Kürze.",

  // Admin
  "admin.login.eyebrow": "Administration",
  "admin.login.title": "Anmeldung",
  "admin.login.email": "E-Mail",
  "admin.login.password": "Passwort",
  "admin.login.submit": "Anmelden",
  "admin.login.submitting": "Anmelden…",
  "admin.login.welcome": "Willkommen zurück.",
  "admin.login.failed": "Login fehlgeschlagen.",
  "admin.dash.eyebrow": "Admin · Dashboard",
  "admin.dash.title": "Anfragen",
  "admin.dash.signed_as": "Angemeldet als",
  "admin.dash.refresh": "Aktualisieren",
  "admin.dash.logout": "Abmelden",
  "admin.dash.empty": "Noch keine Anfragen.",
  "admin.dash.loading": "Lade Anfragen…",
  "admin.dash.stat_total": "Gesamt",
  "admin.dash.stat_week": "Diese Woche",
  "admin.dash.stat_today": "Heute",
  "admin.dash.stat_phone": "Mit Telefon",
  "admin.dash.col_name": "Name",
  "admin.dash.col_email": "E-Mail",
  "admin.dash.col_size": "Wohnung",
  "admin.dash.col_date": "Datum",
  "admin.dash.col_action": "Aktion",
  "admin.dash.detail_eyebrow": "Anfrage Detail",
  "admin.dash.detail_phone": "Telefon",
  "admin.dash.detail_size": "Wohnungsgröße",
  "admin.dash.detail_price": "Preisbereich",
  "admin.dash.detail_received": "Eingegangen",
  "admin.dash.detail_message": "Nachricht",
  "admin.dash.confirm_delete": "Anfrage wirklich löschen?",
  "admin.dash.deleted": "Anfrage gelöscht.",
  "admin.dash.delete_failed": "Löschen fehlgeschlagen.",
  "admin.dash.load_failed": "Konnte Anfragen nicht laden.",
  "admin.dash.empty_select": "Wählen Sie eine Anfrage aus, um Details zu sehen.",
  "admin.tabs.inquiries": "Anfragen",
  "admin.tabs.projects": "Projekte",
  "admin.tabs.security": "Sicherheit",
  "admin.sec.title": "Passwort ändern",
  "admin.sec.desc": "Ändere dein Admin-Passwort. Nach dem Ändern wirst du automatisch abgemeldet und musst dich neu anmelden.",
  "admin.sec.current": "Aktuelles Passwort",
  "admin.sec.new": "Neues Passwort",
  "admin.sec.confirm": "Neues Passwort bestätigen",
  "admin.sec.hint": "Mindestens 12 Zeichen.",
  "admin.sec.submit": "Passwort ändern",
  "admin.sec.saving": "Wird geändert…",
  "admin.sec.success": "Passwort geändert. Bitte melde dich neu an.",
  "admin.sec.min": "Das neue Passwort muss mindestens 12 Zeichen haben.",
  "admin.sec.mismatch": "Die neuen Passwörter stimmen nicht überein.",
  "admin.sec.failed": "Passwort konnte nicht geändert werden.",
  "admin.projects.title": "Projekte verwalten",
  "admin.projects.new": "Neues Projekt",
  "admin.projects.edit": "Bearbeiten",
  "admin.projects.delete": "Löschen",
  "admin.projects.confirm_delete": "Projekt wirklich löschen?",
  "admin.projects.deleted": "Projekt gelöscht.",
  "admin.projects.delete_failed": "Löschen fehlgeschlagen.",
  "admin.projects.load_failed": "Konnte Projekte nicht laden.",
  "admin.projects.save_success": "Projekt gespeichert.",
  "admin.projects.save_failed": "Speichern fehlgeschlagen.",
  "admin.projects.col_title": "Titel",
  "admin.projects.col_location": "Standort",
  "admin.projects.col_status": "Status",
  "admin.projects.col_year": "Jahr",
  "admin.projects.col_category": "Kategorie",
  "admin.projects.col_translations": "Übersetzungen",
  "admin.projects.col_action": "Aktion",
  "admin.projects.empty": "Noch keine Projekte.",
  "admin.projects.form_title_create": "Neues Projekt anlegen",
  "admin.projects.form_title_edit": "Projekt bearbeiten",
  "admin.projects.field_title": "Titel",
  "admin.projects.field_slug": "Slug (URL)",
  "admin.projects.field_location": "Standort",
  "admin.projects.field_status": "Status",
  "admin.projects.field_year": "Jahr",
  "admin.projects.field_category": "Kategorie",
  "admin.projects.field_short_description": "Kurzbeschreibung",
  "admin.projects.field_description": "Beschreibung",
  "admin.projects.field_cover_image": "Titelbild (URL)",
  "admin.projects.field_images": "Weitere Bilder (URLs)",
  "admin.projects.field_video_url": "Video-URL (optional)",
  "admin.projects.field_highlights": "Highlights",
  "admin.projects.field_specs": "Eigenschaften (Key/Wert)",
  "admin.projects.field_floorplans": "Grundrisse (PDF-Links)",
  "admin.projects.field_energy_certificate": "Energieausweis (PDF)",
  "admin.projects.add_item": "Hinzufügen",
  "admin.projects.cancel": "Abbrechen",
  "admin.projects.save": "Speichern",
  "admin.projects.saving": "Speichern…",
  "admin.projects.spec_key_placeholder": "Bezeichnung",
  "admin.projects.spec_value_placeholder": "Wert",
  "admin.projects.floorplan_label_placeholder": "Bezeichnung (z. B. Erdgeschoß)",
  "admin.projects.floorplan_url_placeholder": "PDF-URL",
  "admin.projects.image_url_placeholder": "Bild-URL",
  "admin.projects.highlight_placeholder": "Highlight-Text",
  "admin.projects.upload_file": "Datei hochladen",
  "admin.projects.upload_success": "Datei hochgeladen.",
  "admin.projects.upload_failed": "Upload fehlgeschlagen.",
  "admin.projects.alt_text_label": "Alt-Text-Vorschlag",

  "admin.projects.suggest_button": "KI-Vorschlag",
  "admin.projects.suggest_success": "Vorschlag übernommen.",
  "admin.projects.suggest_failed": "KI-Vorschlag fehlgeschlagen.",
  "admin.projects.suggest_needs_title_location": "Bitte zuerst Titel und Standort ausfüllen.",
  "admin.projects.translate_button": "Automatisch übersetzen",
  "admin.projects.translate_success": "Übersetzungen übernommen.",
  "admin.projects.translate_failed": "Übersetzung fehlgeschlagen.",
  "admin.projects.translate_needs_de": "Bitte zuerst deutsche Kurzbeschreibung und Beschreibung ausfüllen.",
  "admin.projects.translate_hint": "Deutsch ist die Hauptsprache. Klicken Sie auf „Automatisch übersetzen“, um EN/RU/UK zu befüllen.",





  // Budova
  "budova.eyebrow": "Technologie-Partner",
  "budova.title.l1": "Das Budova",
  "budova.title.l2": "Ökosystem.",
  "budova.lede":
    "Seit 1990 zählt Budova zu den führenden Bauunternehmen im Süden der Ukraine. Mit über 30 Wohnkomplexen, 1.000.000 m² fertigem Wohnraum und einem Zuhause für mehr als 30.000 Familien ist Budova der technologische Backbone unserer Vorfertigung und unseres BIM-ERP-Systems.",
  "budova.stat.years": "Jahre Erfahrung (seit 1990)",
  "budova.stat.complexes": "Wohnkomplexe",
  "budova.stat.sqm": "m² fertig gebaut",
  "budova.stat.families": "Familien beheimatet",
  "budova.stat.pace": "Wohngeschosse pro Monat gebaut",
  "budova.story.eyebrow": "Die Geschichte",
  "budova.story.title": "30 Jahre industrielles Bauen.",
  "budova.story.body":
    "Budova ist eine der größten Baufirmen im Süden der Ukraine, anerkannter Marktführer im Wohnungsbau in Odessa. In 30 Jahren hat das Unternehmen das Vertrauen tausender Familien gewonnen und über 60 Objekte fertiggestellt — mehr als die Hälfte davon Wohnkomplexe.",
  "budova.system.eyebrow": "Das Ökosystem",
  "budova.system.title.l1": "BIM-basiertes ERP.",
  "budova.system.title.l2": "Industrielle Vorfertigung.",
  "budova.system.title.l3": "Eindeutige Bauteilkennzeichnung.",
  "budova.cta": "Mehr zu Budova auf budova.ua",

  // Imprint / Privacy
  "imprint.eyebrow": "Impressum",
  "imprint.title": "Anbieter & Verantwortlicher.",
  "privacy.eyebrow": "Datenschutz",
  "privacy.title": "Ihre Daten · Ihre Kontrolle.",

  // Language switcher
  "lang.label": "Sprache",
};

const en = {
  "nav.home": "Home",
  "nav.services": "Services",
  "nav.projects": "Projects",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.partner_budova": "Partner Budova",
  "nav.cta": "Request Consultation",
  "nav.login": "Sign in",
  "nav.account": "My Account",
  "konto.unauth": "Please sign in to view your account.",
  "konto.logout": "Sign out",
  "konto.welcome": "Welcome back",

  "konto.favorites_title": "Saved projects",
  "konto.favorites_empty": "No saved projects yet.",
  "konto.inquiries_title": "My inquiries",
  "konto.inquiries_empty": "No inquiries sent yet.",


  "common.back_to_overview": "Back to overview",
  "common.read_more": "Read more",
  "common.view_all": "View all",
  "common.scroll_explore": "Scroll · Explore",
  "common.send": "Send Inquiry",
  "common.submitting": "Sending…",
  "common.required_short": "Required",
  "common.protected_area": "Protected area · Authorised access only",
  "common.choose": "Please select",
  "common.years_experience": "Years of experience",
  "common.projects_realised": "Projects realised",
  "common.sqm_built": "m² built",
  "common.sqm_managed": "m² under management",
  "common.address": "Address",
  "common.email": "Email",
  "common.phone": "Phone",
  "common.opening_hours": "Opening hours",
  "common.imprint": "Imprint",
  "common.privacy": "Privacy",
  "common.admin": "Admin",
  "common.all_rights": "All rights reserved.",
  "common.partner": "Technology partner",

  "home.eyebrow": "Royalhouse Bauträger GmbH · Vienna",
  "home.hero.title.l1": "Where modern",
  "home.hero.title.l2_pre": "",
  "home.hero.title.l2_em": "living",
  "home.hero.title.l2_post": "meets",
  "home.hero.title.l3_pre": "timeless",
  "home.hero.title.l3_em": "design",
  "home.hero.title.l4": ".",
  "home.hero.lede":
    "From the first idea through BIM planning and serial prefabrication to construction, installation and operations — we deliver buildings end-to-end digitally planned, prefabricated and traceable.",
  "home.hero.cta_primary": "View Projects",
  "home.hero.cta_secondary": "Request Consultation",

  "home.intro.eyebrow": "01 · Philosophy",
  "home.intro.title": "Building as a continuous ecosystem.",
  "home.intro.body":
    "Over 30 years we have realised more than 60 projects with around 1,000,000 m² and currently manage over 750,000 m² of residential space. All processes are orchestrated within the Budova ecosystem with a BIM-based ERP system — transparent, precise and sustainable.",
  "home.intro.body2":
    "Our standard: deliver high-quality apartments in Vienna faster, more precisely and more transparently than the market — through serial prefabrication and industrial quality assurance.",
  "home.intro.cta": "More about us",

  "home.e2e.eyebrow": "02 · End-to-End Building System",
  "home.e2e.title.l1": "Digitally planned.",
  "home.e2e.title.l2": "Industrially fabricated.",
  "home.e2e.title.l3": "Traceably built.",
  "home.e2e.cta": "All services",

  "home.projects.eyebrow": "03 · Projects",
  "home.projects.title.l1": "Current",
  "home.projects.title.l2": "Highlights",
  "home.projects.cta": "All projects",
  "home.prod.eyebrow": "In-house production",
  "home.prod.title": "All concrete. A+++.",
  "home.prod.body": "We build with our own industrial precast production — BIM planning, GRC precast, assembly and completion from a single source. Earthquake-safe up to magnitude 9.5, energy-efficient in class A+++.",
  "home.prod.cta": "View production",
  "home.prod.fact1": "Production floor",
  "home.prod.fact2": "Earthquake-safe",
  "home.prod.fact3": "Energy class",

  "home.cta.eyebrow": "04 · Inquiry",
  "home.cta.title.l1": "Secure your",
  "home.cta.title.l2": "",
  "home.cta.title.l2_em": "well-being",
  "home.cta.title.l3": "lifestyle today.",
  "home.cta.lede": "Limited availability — register now and reserve your home.",
  "home.cta.btn": "Book appointment",

  "services.eyebrow": "Services",
  "services.title.l1": "End-to-End",
  "services.title.l2": "Building System.",
  "services.lede":
    "We deliver buildings end-to-end digitally planned, prefabricated and traceable — from first modelling to handover. The core is a BIM-based process chain plus industrial prefabrication with unique tagging of every component.",
  "services.timeline.eyebrow": "Schedule · Example",
  "services.timeline.title.l1": "New build",
  "services.timeline.title.l2": "6,000 m² GFA",
  "services.timeline.title.l3": "in 23 weeks.",
  "services.timeline.lede":
    "From model to handover: an example takt schedule of our E2E system — from BIM workflow through factory prefabrication to commissioning.",
  "services.apartments.eyebrow": "Apartment floor plans",
  "services.apartments.title.l1": "Tailored",
  "services.apartments.title.l2": "floor plans for every",
  "services.apartments.title.l3": "lifestyle.",
  "services.equipment.eyebrow": "Features & Equipment",
  "services.equipment.title.l1": "Everything that makes",
  "services.equipment.title.l2": "everyday life easier.",
  "services.cta_projects": "View Projects",
  "services.cta_contact": "Request Consultation",

  "projects.eyebrow": "Projects",
  "projects.title.l1": "Living with",
  "projects.title.l2": "character.",
  "projects.lede":
    "60+ projects realised. ~1,000,000 m² built. Currently under management: more than 750,000 m². A selection of current and past developments.",
  "projects.filter.category": "Category:",
  "projects.filter.status": "Status:",
  "projects.filter.all": "All",
  "projects.filter.villa": "Villas",
  "projects.filter.einfamilienhaus": "Detached houses",
  "projects.filter.reihenhaus": "Terrace houses",
  "projects.filter.stadthaus": "Townhouses",
  "projects.filter.wohnbau": "Apartments",
  "projects.filter.sanierung": "Refurbishment",
  "projects.filter.infrastruktur": "Infrastructure",
  "projects.empty": "No projects found.",
  "projects.loading": "Loading projects…",
  "projects.card.details": "View details",
  "projects.card.energy_class": "A+++ Energy Class",
  "projects.card.certified": "Certified to ÖNORM · klimaaktiv",

  "project.about_eyebrow": "About the project",
  "project.video_eyebrow": "Project video",
  "project.video_title": "The location in motion.",
  "project.video_lede": "A cinematic overview of location, architecture and neighbourhood — filmed on site.",
  "project.about_title": "Architecture & concept",
  "project.highlights": "Highlights",
  "project.floorplans": "Floor plans",
  "project.energy_certificate": "Energy certificate",
  "project.energy_certificate_download": "Download energy certificate",
  "chat.button_label": "Ask a question",
  "chat.title": "Royal House Assistant",
  "chat.subtitle": "Questions about our projects",
  "chat.placeholder": "Your question…",
  "chat.send": "Send",
  "chat.greeting": "Good day! I'm happy to answer questions about our projects in Vienna, Styria, Salzburg and Ukraine. How can I help?",
  "chat.error": "The assistant is currently unavailable. Please try again later or use the contact form.",
  "chat.close": "Close",
  "chat.thinking": "Replying…",
  "chat.suggestion_1": "Which projects do you have in Vienna?",
  "chat.suggestion_2": "How can I contact you?",
  "chat.suggestion_3": "What makes Royal House different?",



  "project.specs": "Key facts",
  "project.cta_inquire": "Send inquiry",
  "project.not_found": "Project not found.",

  "about.eyebrow": "About",
  "about.title.l1": "Excellence",
  "about.title.l2": "you can",
  "about.title.l2_em": "trust.",
  "about.lede":
    "Royal House Bauträger GmbH, based in Vienna, develops, plans and builds residential projects in the upper segment. We combine classic developer expertise with modern BIM planning, precise prefabrication and an international partner network. Building services are delivered with our MEP partner ECO Building Technik.",
  "about.values.eyebrow": "Our values",
  "about.team.eyebrow": "Management & Partners",
  "about.team.title.l1": "People who take",
  "about.team.title.l2": "responsibility.",
  "about.architects.eyebrow": "Top architects · Cooperation alliance",
  "about.architects.title.l1": "International top architects",
  "about.architects.title.l2": "in our alliance.",
  "about.partners.eyebrow": "Partner companies",
  "about.partners.title": "Our network.",
  "about.cta.title.l1": "Let's build",
  "about.cta.title.l2": "together.",
  "about.cta.title.l2_em": "",

  "contact.eyebrow": "Contact",
  "contact.title.l1": "Let's talk",
  "contact.title.l2": "about your",
  "contact.title.l2_em": "home.",
  "contact.lede":
    "Book a meeting or request more information — our sales team will get back to you within 24 hours.",
  "contact.form.eyebrow": "Send inquiry",
  "contact.form.title": "Book an appointment",
  "contact.wellbeing.eyebrow": "Healthy living · Technology partner",
  "contact.wellbeing.title": "Well-Being ConTech.",
  "contact.wellbeing.body": "Healthy, energy-efficient living flows directly into our projects — from low-emission materials to smart-home controls.",
  "contact.wellbeing.cta_partner": "View partner page",
  "contact.wellbeing.cta_external": "wellbeingcontech.com",
  "contact.form.first_name": "First name *",
  "contact.form.last_name": "Last name *",
  "contact.form.email": "Email *",
  "contact.form.phone": "Phone",
  "contact.form.residence_size": "Apartment size",
  "contact.form.price_range": "Price range",
  "contact.form.message": "Message",
  "contact.form.message_placeholder": "Your wishes, questions or preferred date",
  "contact.form.privacy_note":
    "By submitting you agree to our privacy policy. Your data will be used solely to handle your inquiry.",
  "contact.success.title": "Thank you!",
  "contact.success.body":
    "Your inquiry has been received. Our sales team will respond within 24 hours.",
  "contact.success.new": "Submit a new inquiry →",
  "contact.error.required": "Please fill in first name, last name and email.",
  "contact.error.generic": "Inquiry could not be sent.",
  "contact.success.toast": "Thank you! We will be in touch shortly.",

  "admin.login.eyebrow": "Administration",
  "admin.login.title": "Sign in",
  "admin.login.email": "Email",
  "admin.login.password": "Password",
  "admin.login.submit": "Sign in",
  "admin.login.submitting": "Signing in…",
  "admin.login.welcome": "Welcome back.",
  "admin.login.failed": "Login failed.",
  "admin.dash.eyebrow": "Admin · Dashboard",
  "admin.dash.title": "Inquiries",
  "admin.dash.signed_as": "Signed in as",
  "admin.dash.refresh": "Refresh",
  "admin.dash.logout": "Log out",
  "admin.dash.empty": "No inquiries yet.",
  "admin.dash.loading": "Loading inquiries…",
  "admin.dash.stat_total": "Total",
  "admin.dash.stat_week": "This week",
  "admin.dash.stat_today": "Today",
  "admin.dash.stat_phone": "With phone",
  "admin.dash.col_name": "Name",
  "admin.dash.col_email": "Email",
  "admin.dash.col_size": "Apartment",
  "admin.dash.col_date": "Date",
  "admin.dash.col_action": "Action",
  "admin.dash.detail_eyebrow": "Inquiry detail",
  "admin.dash.detail_phone": "Phone",
  "admin.dash.detail_size": "Apartment size",
  "admin.dash.detail_price": "Price range",
  "admin.dash.detail_received": "Received",
  "admin.dash.detail_message": "Message",
  "admin.dash.confirm_delete": "Really delete this inquiry?",
  "admin.dash.deleted": "Inquiry deleted.",
  "admin.dash.delete_failed": "Deletion failed.",
  "admin.dash.load_failed": "Could not load inquiries.",
  "admin.dash.empty_select": "Select an inquiry to see details.",
  "admin.tabs.inquiries": "Inquiries",
  "admin.tabs.projects": "Projects",
  "admin.tabs.security": "Security",
  "admin.sec.title": "Change password",
  "admin.sec.desc": "Change your admin password. After changing it you will be signed out automatically and must log in again.",
  "admin.sec.current": "Current password",
  "admin.sec.new": "New password",
  "admin.sec.confirm": "Confirm new password",
  "admin.sec.hint": "At least 12 characters.",
  "admin.sec.submit": "Change password",
  "admin.sec.saving": "Changing…",
  "admin.sec.success": "Password changed. Please sign in again.",
  "admin.sec.min": "The new password must be at least 12 characters.",
  "admin.sec.mismatch": "The new passwords do not match.",
  "admin.sec.failed": "Could not change the password.",
  "admin.projects.title": "Manage projects",
  "admin.projects.new": "New project",
  "admin.projects.edit": "Edit",
  "admin.projects.delete": "Delete",
  "admin.projects.confirm_delete": "Really delete this project?",
  "admin.projects.deleted": "Project deleted.",
  "admin.projects.delete_failed": "Deletion failed.",
  "admin.projects.load_failed": "Could not load projects.",
  "admin.projects.save_success": "Project saved.",
  "admin.projects.save_failed": "Saving failed.",
  "admin.projects.col_title": "Title",
  "admin.projects.col_location": "Location",
  "admin.projects.col_status": "Status",
  "admin.projects.col_year": "Year",
  "admin.projects.col_category": "Category",
  "admin.projects.col_translations": "Translations",
  "admin.projects.col_action": "Action",
  "admin.projects.empty": "No projects yet.",
  "admin.projects.form_title_create": "Create new project",
  "admin.projects.form_title_edit": "Edit project",
  "admin.projects.field_title": "Title",
  "admin.projects.field_slug": "Slug (URL)",
  "admin.projects.field_location": "Location",
  "admin.projects.field_status": "Status",
  "admin.projects.field_year": "Year",
  "admin.projects.field_category": "Category",
  "admin.projects.field_short_description": "Short description",
  "admin.projects.field_description": "Description",
  "admin.projects.field_cover_image": "Cover image (URL)",
  "admin.projects.field_images": "Additional images (URLs)",
  "admin.projects.field_video_url": "Video URL (optional)",
  "admin.projects.field_highlights": "Highlights",
  "admin.projects.field_specs": "Specs (key/value)",
  "admin.projects.field_floorplans": "Floor plans (PDF links)",
  "admin.projects.field_energy_certificate": "Energy certificate (PDF)",
  "admin.projects.add_item": "Add",
  "admin.projects.cancel": "Cancel",
  "admin.projects.save": "Save",
  "admin.projects.saving": "Saving…",
  "admin.projects.spec_key_placeholder": "Label",
  "admin.projects.spec_value_placeholder": "Value",
  "admin.projects.floorplan_label_placeholder": "Label (e.g. ground floor)",
  "admin.projects.floorplan_url_placeholder": "PDF URL",
  "admin.projects.image_url_placeholder": "Image URL",
  "admin.projects.highlight_placeholder": "Highlight text",
  "admin.projects.upload_file": "Upload file",
  "admin.projects.upload_success": "File uploaded.",
  "admin.projects.upload_failed": "Upload failed.",
  "admin.projects.alt_text_label": "AI alt-text suggestion",

  "admin.projects.suggest_button": "AI suggestion",
  "admin.projects.suggest_success": "Suggestion applied.",
  "admin.projects.suggest_failed": "AI suggestion failed.",
  "admin.projects.suggest_needs_title_location": "Please fill in title and location first.",
  "admin.projects.translate_button": "Auto-translate",
  "admin.projects.translate_success": "Translations applied.",
  "admin.projects.translate_failed": "Translation failed.",
  "admin.projects.translate_needs_de": "Please fill in the German short description and description first.",
  "admin.projects.translate_hint": "German is the primary language. Click \"Auto-translate\" to fill EN/RU/UK.",





  "budova.eyebrow": "Technology partner",
  "budova.title.l1": "The Budova",
  "budova.title.l2": "ecosystem.",
  "budova.lede":
    "Since 1990, Budova has been one of the leading construction companies in southern Ukraine. With more than 30 residential complexes, 1,000,000 m² of completed living space and a home for over 30,000 families, Budova is the technological backbone of our prefabrication and BIM-ERP system.",
  "budova.stat.years": "Years of experience (since 1990)",
  "budova.stat.complexes": "Residential complexes",
  "budova.stat.sqm": "m² completed",
  "budova.stat.families": "Families housed",
  "budova.stat.pace": "Residential floors built per month",
  "budova.story.eyebrow": "The story",
  "budova.story.title": "30 years of industrial construction.",
  "budova.story.body":
    "Budova is one of the largest construction companies in southern Ukraine, a recognised leader in residential construction in Odesa. In 30 years the company has earned the trust of thousands of families and completed more than 60 buildings — over half of them residential complexes.",
  "budova.system.eyebrow": "The ecosystem",
  "budova.system.title.l1": "BIM-based ERP.",
  "budova.system.title.l2": "Industrial prefabrication.",
  "budova.system.title.l3": "Unique component tagging.",
  "budova.cta": "Learn more at budova.ua",

  "imprint.eyebrow": "Imprint",
  "imprint.title": "Provider & responsible party.",
  "privacy.eyebrow": "Privacy",
  "privacy.title": "Your data · your control.",

  "lang.label": "Language",
};

const ru = {
  "nav.home": "Главная",
  "nav.services": "Услуги",
  "nav.projects": "Проекты",
  "nav.about": "О нас",
  "nav.contact": "Контакты",
  "nav.partner_budova": "Партнёр Budova",
  "nav.cta": "Заказать консультацию",
  "nav.login": "Войти",
  "nav.account": "Мой кабинет",
  "konto.unauth": "Пожалуйста, войдите, чтобы увидеть свой кабинет.",
  "konto.logout": "Выйти",
  "konto.welcome": "С возвращением",

  "konto.favorites_title": "Сохранённые проекты",
  "konto.favorites_empty": "Пока нет сохранённых проектов.",
  "konto.inquiries_title": "Мои запросы",
  "konto.inquiries_empty": "Пока нет отправленных запросов.",


  "common.back_to_overview": "Назад к списку",
  "common.read_more": "Подробнее",
  "common.view_all": "Смотреть всё",
  "common.scroll_explore": "Прокрутка · Исследовать",
  "common.send": "Отправить запрос",
  "common.submitting": "Отправка…",
  "common.required_short": "Обязательно",
  "common.protected_area": "Защищённая зона · Только авторизованный доступ",
  "common.choose": "Выберите",
  "common.years_experience": "Лет опыта",
  "common.projects_realised": "Реализованных проектов",
  "common.sqm_built": "м² построено",
  "common.sqm_managed": "м² в управлении",
  "common.address": "Адрес",
  "common.email": "E-mail",
  "common.phone": "Телефон",
  "common.opening_hours": "Часы работы",
  "common.imprint": "Реквизиты",
  "common.privacy": "Конфиденциальность",
  "common.admin": "Админ",
  "common.all_rights": "Все права защищены.",
  "common.partner": "Технологический партнёр",

  "home.eyebrow": "Royalhouse Bauträger GmbH · Вена",
  "home.hero.title.l1": "Где современная",
  "home.hero.title.l2_pre": "",
  "home.hero.title.l2_em": "жизнь",
  "home.hero.title.l2_post": "встречает",
  "home.hero.title.l3_pre": "вечный",
  "home.hero.title.l3_em": "дизайн",
  "home.hero.title.l4": ".",
  "home.hero.lede":
    "От первой идеи через BIM-планирование и серийное производство до строительства, монтажа и эксплуатации — мы создаём здания, спроектированные цифрово, изготовленные индустриально и полностью прослеживаемые.",
  "home.hero.cta_primary": "Смотреть проекты",
  "home.hero.cta_secondary": "Заказать консультацию",

  "home.intro.eyebrow": "01 · Философия",
  "home.intro.title": "Строительство как единая экосистема.",
  "home.intro.body":
    "За 30 лет мы реализовали более 60 проектов общей площадью около 1 000 000 м² и сейчас управляем более 750 000 м² жилой площади. Все процессы координируются в экосистеме Budova с BIM-ERP — прозрачно, точно, экологично.",
  "home.intro.body2":
    "Наша задача: поставлять качественные квартиры в Вене быстрее, точнее и прозрачнее рынка — через серийное производство и индустриальный контроль качества.",
  "home.intro.cta": "О нас подробнее",

  "home.e2e.eyebrow": "02 · End-to-End строительство",
  "home.e2e.title.l1": "Спроектировано цифрово.",
  "home.e2e.title.l2": "Изготовлено индустриально.",
  "home.e2e.title.l3": "Прослеживаемо построено.",
  "home.e2e.cta": "Все услуги",

  "home.projects.eyebrow": "03 · Проекты",
  "home.projects.title.l1": "Текущие",
  "home.projects.title.l2": "новинки",
  "home.projects.cta": "Все проекты",
  "home.prod.eyebrow": "Собственное производство",
  "home.prod.title": "Всё из бетона. A+++.",
  "home.prod.body": "Мы строим на собственном промышленном производстве сборных элементов — BIM-проектирование, GRC-элементы, монтаж и сдача из одних рук. Сейсмостойкость до магнитуды 9,5, энергоэффективность класса A+++.",
  "home.prod.cta": "Смотреть производство",
  "home.prod.fact1": "Производственная площадь",
  "home.prod.fact2": "Сейсмостойкость",
  "home.prod.fact3": "Класс энергоэффективности",

  "home.cta.eyebrow": "04 · Запрос",
  "home.cta.title.l1": "Обеспечьте себе",
  "home.cta.title.l2": "стиль жизни",
  "home.cta.title.l2_em": "well-being",
  "home.cta.title.l3": "уже сегодня.",
  "home.cta.lede": "Ограниченное количество — забронируйте свою квартиру.",
  "home.cta.btn": "Записаться",

  "services.eyebrow": "Услуги",
  "services.title.l1": "End-to-End",
  "services.title.l2": "стройсистема.",
  "services.lede":
    "Мы строим здания, цифрово спроектированные, изготовленные индустриально и полностью прослеживаемые — от модели до сдачи. В основе — BIM-цепочка и серийное производство с уникальной маркировкой каждой детали.",
  "services.timeline.eyebrow": "График · Пример",
  "services.timeline.title.l1": "Новостройка",
  "services.timeline.title.l2": "6 000 м² БГП",
  "services.timeline.title.l3": "за 23 недели.",
  "services.timeline.lede":
    "От модели до сдачи: пример тактового графика E2E — от BIM до пусконаладки.",
  "services.apartments.eyebrow": "Планировки квартир",
  "services.apartments.title.l1": "Индивидуальные",
  "services.apartments.title.l2": "планировки под",
  "services.apartments.title.l3": "любой стиль жизни.",
  "services.equipment.eyebrow": "Оснащение и сервис",
  "services.equipment.title.l1": "Всё, что делает",
  "services.equipment.title.l2": "повседневную жизнь проще.",
  "services.cta_projects": "Смотреть проекты",
  "services.cta_contact": "Заказать консультацию",

  "projects.eyebrow": "Проекты",
  "projects.title.l1": "Жильё с",
  "projects.title.l2": "характером.",
  "projects.lede":
    "60+ реализованных проектов. ~1 000 000 м² построенной площади. В управлении: более 750 000 м². Подборка текущих и завершённых объектов.",
  "projects.filter.category": "Категория:",
  "projects.filter.status": "Статус:",
  "projects.filter.all": "Все",
  "projects.filter.villa": "Виллы",
  "projects.filter.einfamilienhaus": "Одноквартирные дома",
  "projects.filter.reihenhaus": "Рядные дома",
  "projects.filter.stadthaus": "Таунхаусы",
  "projects.filter.wohnbau": "Квартиры",
  "projects.filter.sanierung": "Реновация",
  "projects.filter.infrastruktur": "Инфраструктура",
  "projects.empty": "Проекты не найдены.",
  "projects.loading": "Загрузка проектов…",
  "projects.card.details": "Подробнее",
  "projects.card.energy_class": "Класс A+++",
  "projects.card.certified": "Сертифицировано по ÖNORM · klimaaktiv",

  "project.about_eyebrow": "О проекте",
  "project.video_eyebrow": "Видео проекта",
  "project.video_title": "Локация в кадре.",
  "project.video_lede": "Кинематографический обзор локации, архитектуры и квартала — съёмка на месте.",
  "project.about_title": "Архитектура и концепция",
  "project.highlights": "Преимущества",
  "project.floorplans": "Планы этажей",
  "project.energy_certificate": "Энергетический паспорт",
  "project.energy_certificate_download": "Скачать энергетический паспорт",
  "chat.button_label": "Задать вопрос",
  "chat.title": "Ассистент Royal House",
  "chat.subtitle": "Вопросы о наших проектах",
  "chat.placeholder": "Ваш вопрос…",
  "chat.send": "Отправить",
  "chat.greeting": "Добрый день! Готов ответить на вопросы о наших проектах в Вене, Штирии, Зальцбурге и Украине. Как я могу помочь?",
  "chat.error": "Ассистент временно недоступен. Попробуйте позже или воспользуйтесь формой обратной связи.",
  "chat.close": "Закрыть",
  "chat.thinking": "Печатает…",
  "chat.suggestion_1": "Какие проекты есть в Вене?",
  "chat.suggestion_2": "Как с вами связаться?",
  "chat.suggestion_3": "Чем отличается Royal House?",



  "project.specs": "Ключевые данные",
  "project.cta_inquire": "Отправить запрос",
  "project.not_found": "Проект не найден.",

  "about.eyebrow": "О нас",
  "about.title.l1": "Совершенство,",
  "about.title.l2": "которому можно",
  "about.title.l2_em": "доверять.",
  "about.lede":
    "Royal House Bauträger GmbH со штаб-квартирой в Вене проектирует и реализует жилые объекты в верхнем сегменте. Мы сочетаем классический опыт застройщика с BIM-проектированием, точной префабрикацией и международной партнёрской сетью. Инженерные системы — наш партнёр ECO Building Technik.",
  "about.values.eyebrow": "Наши ценности",
  "about.team.eyebrow": "Руководство и партнёры",
  "about.team.title.l1": "Люди, которые берут",
  "about.team.title.l2": "ответственность.",
  "about.architects.eyebrow": "Топ-архитекторы · Альянс",
  "about.architects.title.l1": "Международные топ-архитекторы",
  "about.architects.title.l2": "в нашем альянсе.",
  "about.partners.eyebrow": "Компании-партнёры",
  "about.partners.title": "Наша сеть.",
  "about.cta.title.l1": "Давайте",
  "about.cta.title.l2": "построим вместе.",
  "about.cta.title.l2_em": "",

  "contact.eyebrow": "Контакты",
  "contact.title.l1": "Поговорим",
  "contact.title.l2": "о вашем",
  "contact.title.l2_em": "доме.",
  "contact.lede":
    "Запишитесь на встречу или запросите подробности — наш отдел продаж ответит в течение 24 часов.",
  "contact.form.eyebrow": "Отправить запрос",
  "contact.form.title": "Записаться на встречу",
  "contact.wellbeing.eyebrow": "Здоровое жильё · Технологический партнёр",
  "contact.wellbeing.title": "Well-Being ConTech.",
  "contact.wellbeing.body": "Здоровое и энергоэффективное жильё напрямую внедряется в наши проекты — от низкоэмиссионных материалов до умного дома.",
  "contact.wellbeing.cta_partner": "На страницу партнёра",
  "contact.wellbeing.cta_external": "wellbeingcontech.com",
  "contact.form.first_name": "Имя *",
  "contact.form.last_name": "Фамилия *",
  "contact.form.email": "E-mail *",
  "contact.form.phone": "Телефон",
  "contact.form.residence_size": "Площадь квартиры",
  "contact.form.price_range": "Диапазон цен",
  "contact.form.message": "Сообщение",
  "contact.form.message_placeholder": "Ваши пожелания, вопросы или удобная дата",
  "contact.form.privacy_note":
    "Отправляя форму, вы принимаете нашу политику конфиденциальности. Данные используются только для обработки запроса.",
  "contact.success.title": "Спасибо!",
  "contact.success.body":
    "Запрос получен. Отдел продаж свяжется с вами в течение 24 часов.",
  "contact.success.new": "Отправить новый запрос →",
  "contact.error.required": "Пожалуйста, заполните имя, фамилию и e-mail.",
  "contact.error.generic": "Не удалось отправить запрос.",
  "contact.success.toast": "Спасибо! Мы скоро свяжемся.",

  "admin.login.eyebrow": "Администрирование",
  "admin.login.title": "Вход",
  "admin.login.email": "E-mail",
  "admin.login.password": "Пароль",
  "admin.login.submit": "Войти",
  "admin.login.submitting": "Вход…",
  "admin.login.welcome": "С возвращением.",
  "admin.login.failed": "Ошибка входа.",
  "admin.dash.eyebrow": "Админ · Панель",
  "admin.dash.title": "Запросы",
  "admin.dash.signed_as": "Вы вошли как",
  "admin.dash.refresh": "Обновить",
  "admin.dash.logout": "Выйти",
  "admin.dash.empty": "Запросов пока нет.",
  "admin.dash.loading": "Загрузка запросов…",
  "admin.dash.stat_total": "Всего",
  "admin.dash.stat_week": "За неделю",
  "admin.dash.stat_today": "Сегодня",
  "admin.dash.stat_phone": "С телефоном",
  "admin.dash.col_name": "Имя",
  "admin.dash.col_email": "E-mail",
  "admin.dash.col_size": "Квартира",
  "admin.dash.col_date": "Дата",
  "admin.dash.col_action": "Действие",
  "admin.dash.detail_eyebrow": "Детали запроса",
  "admin.dash.detail_phone": "Телефон",
  "admin.dash.detail_size": "Площадь",
  "admin.dash.detail_price": "Бюджет",
  "admin.dash.detail_received": "Получено",
  "admin.dash.detail_message": "Сообщение",
  "admin.dash.confirm_delete": "Удалить запрос?",
  "admin.dash.deleted": "Запрос удалён.",
  "admin.dash.delete_failed": "Не удалось удалить.",
  "admin.dash.load_failed": "Не удалось загрузить запросы.",
  "admin.dash.empty_select": "Выберите запрос, чтобы увидеть детали.",
  "admin.tabs.inquiries": "Запросы",
  "admin.tabs.projects": "Проекты",
  "admin.tabs.security": "Безопасность",
  "admin.sec.title": "Сменить пароль",
  "admin.sec.desc": "Измените пароль администратора. После изменения вы будете автоматически выйдены из системы и должны войти заново.",
  "admin.sec.current": "Текущий пароль",
  "admin.sec.new": "Новый пароль",
  "admin.sec.confirm": "Подтвердите новый пароль",
  "admin.sec.hint": "Минимум 12 символов.",
  "admin.sec.submit": "Сменить пароль",
  "admin.sec.saving": "Изменение…",
  "admin.sec.success": "Пароль изменён. Пожалуйста, войдите заново.",
  "admin.sec.min": "Новый пароль должен содержать не менее 12 символов.",
  "admin.sec.mismatch": "Новые пароли не совпадают.",
  "admin.sec.failed": "Не удалось изменить пароль.",
  "admin.projects.title": "Управление проектами",
  "admin.projects.new": "Новый проект",
  "admin.projects.edit": "Изменить",
  "admin.projects.delete": "Удалить",
  "admin.projects.confirm_delete": "Действительно удалить проект?",
  "admin.projects.deleted": "Проект удалён.",
  "admin.projects.delete_failed": "Удаление не выполнено.",
  "admin.projects.load_failed": "Не удалось загрузить проекты.",
  "admin.projects.save_success": "Проект сохранён.",
  "admin.projects.save_failed": "Сохранение не выполнено.",
  "admin.projects.col_title": "Название",
  "admin.projects.col_location": "Локация",
  "admin.projects.col_status": "Статус",
  "admin.projects.col_year": "Год",
  "admin.projects.col_category": "Категория",
  "admin.projects.col_translations": "Переводы",
  "admin.projects.col_action": "Действие",
  "admin.projects.empty": "Пока нет проектов.",
  "admin.projects.form_title_create": "Создать новый проект",
  "admin.projects.form_title_edit": "Редактировать проект",
  "admin.projects.field_title": "Название",
  "admin.projects.field_slug": "Slug (URL)",
  "admin.projects.field_location": "Локация",
  "admin.projects.field_status": "Статус",
  "admin.projects.field_year": "Год",
  "admin.projects.field_category": "Категория",
  "admin.projects.field_short_description": "Короткое описание",
  "admin.projects.field_description": "Описание",
  "admin.projects.field_cover_image": "Титульное изображение (URL)",
  "admin.projects.field_images": "Дополнительные изображения (URL)",
  "admin.projects.field_video_url": "URL видео (опционально)",
  "admin.projects.field_highlights": "Преимущества",
  "admin.projects.field_specs": "Характеристики (ключ/значение)",
  "admin.projects.field_floorplans": "Планы этажей (PDF-ссылки)",
  "admin.projects.field_energy_certificate": "Энергетический паспорт (PDF)",
  "admin.projects.add_item": "Добавить",
  "admin.projects.cancel": "Отмена",
  "admin.projects.save": "Сохранить",
  "admin.projects.saving": "Сохранение…",
  "admin.projects.spec_key_placeholder": "Обозначение",
  "admin.projects.spec_value_placeholder": "Значение",
  "admin.projects.floorplan_label_placeholder": "Обозначение (напр. первый этаж)",
  "admin.projects.floorplan_url_placeholder": "URL PDF",
  "admin.projects.image_url_placeholder": "URL изображения",
  "admin.projects.highlight_placeholder": "Текст преимущества",
  "admin.projects.upload_file": "Загрузить файл",
  "admin.projects.upload_success": "Файл загружен.",
  "admin.projects.upload_failed": "Загрузка не удалась.",
  "admin.projects.alt_text_label": "AI-предложение alt-текста",

  "admin.projects.suggest_button": "AI-предложение",
  "admin.projects.suggest_success": "Предложение применено.",
  "admin.projects.suggest_failed": "AI-предложение не удалось.",
  "admin.projects.suggest_needs_title_location": "Сначала заполните название и локацию.",
  "admin.projects.translate_button": "Автоперевод",
  "admin.projects.translate_success": "Переводы применены.",
  "admin.projects.translate_failed": "Перевод не удался.",
  "admin.projects.translate_needs_de": "Сначала заполните немецкое короткое описание и описание.",
  "admin.projects.translate_hint": "Немецкий — основной язык. Нажмите «Автоперевод», чтобы заполнить EN/RU/UK.",





  "budova.eyebrow": "Технологический партнёр",
  "budova.title.l1": "Экосистема",
  "budova.title.l2": "Budova.",
  "budova.lede":
    "С 1990 года Budova — один из ведущих застройщиков юга Украины. Более 30 жилых комплексов, 1 000 000 м² готового жилья и дом для более чем 30 000 семей. Budova — технологическая основа нашей префабрикации и BIM-ERP.",
  "budova.stat.years": "Лет опыта (с 1990)",
  "budova.stat.complexes": "Жилых комплексов",
  "budova.stat.sqm": "м² построено",
  "budova.stat.families": "Семей обустроено",
  "budova.stat.pace": "Этажей строится в месяц",
  "budova.story.eyebrow": "История",
  "budova.story.title": "30 лет индустриального строительства.",
  "budova.story.body":
    "Budova — одна из крупнейших строительных компаний юга Украины, лидер жилого строительства в Одессе. За 30 лет компания заслужила доверие тысяч семей и сдала более 60 объектов — больше половины из них жилые комплексы.",
  "budova.system.eyebrow": "Экосистема",
  "budova.system.title.l1": "BIM-ERP.",
  "budova.system.title.l2": "Индустриальная префабрикация.",
  "budova.system.title.l3": "Уникальная маркировка деталей.",
  "budova.cta": "Подробнее на budova.ua",

  "imprint.eyebrow": "Реквизиты",
  "imprint.title": "Поставщик и ответственное лицо.",
  "privacy.eyebrow": "Конфиденциальность",
  "privacy.title": "Ваши данные · ваш контроль.",

  "lang.label": "Язык",
};

const uk = {
"nav.home": "Головна",
  "nav.services": "Послуги",
  "nav.projects": "Проєкти",
  "nav.about": "Про нас",
  "nav.contact": "Контакти",
  "nav.partner_budova": "Партнер Budova",
  "nav.cta": "Замовити консультацію",
  "nav.login": "Увійти",
  "nav.account": "Мій кабінет",
  "konto.unauth": "Будь ласка, увійдіть, щоб побачити свій кабінет.",
  "konto.logout": "Вийти",
  "konto.welcome": "З поверненням",

  "konto.favorites_title": "Збережені проєкти",
  "konto.favorites_empty": "Поки немає збережених проєктів.",
  "konto.inquiries_title": "Мої запити",
  "konto.inquiries_empty": "Поки немає надісланих запитів.",


  "common.back_to_overview": "Назад до списку",
  "common.read_more": "Детальніше",
  "common.view_all": "Переглянути все",
  "common.scroll_explore": "Прокрутити · Дослідити",
  "common.send": "Надіслати запит",
  "common.submitting": "Надсилання…",
  "common.required_short": "Обов'язково",
  "common.protected_area": "Захищена зона · Тільки авторизований доступ",
  "common.choose": "Оберіть",
  "common.years_experience": "Років досвіду",
  "common.projects_realised": "Реалізованих проєктів",
  "common.sqm_built": "м² побудовано",
  "common.sqm_managed": "м² в управлінні",
  "common.address": "Адреса",
  "common.email": "E-mail",
  "common.phone": "Телефон",
  "common.opening_hours": "Години роботи",
  "common.imprint": "Реквізити",
  "common.privacy": "Конфіденційність",
  "common.admin": "Адмін",
  "common.all_rights": "Усі права захищені.",
  "common.partner": "Технологічний партнер",

  "home.eyebrow": "Royal House Bauträger GmbH · Відень",
  "home.hero.title.l1": "Де сучасне",
  "home.hero.title.l2_pre": "",
  "home.hero.title.l2_em": "життя",
  "home.hero.title.l2_post": "зустрічає",
  "home.hero.title.l3_pre": "вічний",
  "home.hero.title.l3_em": "дизайн",
  "home.hero.title.l4": ".",
  "home.hero.lede":
    "Від першої ідеї через BIM-планування та серійне виробництво до будівництва, монтажу та експлуатації — ми створюємо будівлі, спроєктовані цифровим шляхом, виготовлені індустріально та повністю відстежувані.",
  "home.hero.cta_primary": "Переглянути проєкти",
  "home.hero.cta_secondary": "Замовити консультацію",

  "home.intro.eyebrow": "01 · Філософія",
  "home.intro.title": "Будівництво як єдина екосистема.",
  "home.intro.body":
    "За 30 років ми реалізували понад 60 проєктів загальною площею близько 1 000 000 м² і зараз керуємо понад 750 000 м² житлової площі. Усі процеси координуються в екосистемі Budova з BIM-ERP — прозоро, точно, екологічно.",
  "home.intro.body2":
    "Наше завдання: постачати якісні квартири у Відні швидше, точніше та прозоріше за ринок — через серійне виробництво та індустріальний контроль якості.",
  "home.intro.cta": "Про нас детальніше",

  "home.e2e.eyebrow": "02 · End-to-End будівництво",
  "home.e2e.title.l1": "Спроєктовано цифровим шляхом.",
  "home.e2e.title.l2": "Виготовлено індустріально.",
  "home.e2e.title.l3": "Збудовано з можливістю відстеження.",
  "home.e2e.cta": "Усі послуги",

  "home.projects.eyebrow": "03 · Проєкти",
  "home.projects.title.l1": "Поточні",
  "home.projects.title.l2": "новинки",
  "home.projects.cta": "Усі проєкти",
  "home.prod.eyebrow": "Власне виробництво",
  "home.prod.title": "Усе з бетону. A+++.",
  "home.prod.body": "Ми будуємо на власному промисловому виробництві збірних елементів — BIM-проєктування, GRC-елементи, монтаж і здача з одних рук. Сейсмостійкість до магнітуди 9,5, енергоефективність класу A+++.",
  "home.prod.cta": "Дивитися виробництво",
  "home.prod.fact1": "Виробнича площа",
  "home.prod.fact2": "Сейсмостійкість",
  "home.prod.fact3": "Клас енергоефективності",

  "home.cta.eyebrow": "04 · Запит",
  "home.cta.title.l1": "Забезпечте собі",
  "home.cta.title.l2": "стиль життя",
  "home.cta.title.l2_em": "well-being",
  "home.cta.title.l3": "вже сьогодні.",
  "home.cta.lede": "Обмежена кількість — забронюйте свою квартиру.",
  "home.cta.btn": "Записатись",

  "services.eyebrow": "Послуги",
  "services.title.l1": "End-to-End",
  "services.title.l2": "будівельна система.",
  "services.lede":
    "Ми будуємо будівлі, спроєктовані цифровим шляхом, виготовлені індустріально та повністю відстежувані — від моделі до здачі в експлуатацію. В основі — BIM-ланцюжок та серійне виробництво з унікальним маркуванням кожної деталі.",
  "services.timeline.eyebrow": "Графік · Приклад",
  "services.timeline.title.l1": "Новобудова",
  "services.timeline.title.l2": "6 000 м² БЗП",
  "services.timeline.title.l3": "за 23 тижні.",
  "services.timeline.lede":
    "Від моделі до здачі в експлуатацію: приклад тактового графіку E2E — від BIM до пусконаладки.",
  "services.apartments.eyebrow": "Планування квартир",
  "services.apartments.title.l1": "Індивідуальні",
  "services.apartments.title.l2": "планування під",
  "services.apartments.title.l3": "будь-який стиль життя.",
  "services.equipment.eyebrow": "Оснащення та сервіс",
  "services.equipment.title.l1": "Усе, що робить",
  "services.equipment.title.l2": "повсякденне життя простішим.",
  "services.cta_projects": "Переглянути проєкти",
  "services.cta_contact": "Замовити консультацію",

  "projects.eyebrow": "Проєкти",
  "projects.title.l1": "Житло з",
  "projects.title.l2": "характером.",
  "projects.lede":
    "Понад 60 реалізованих проєктів. ~1 000 000 м² збудованої площі. В управлінні: понад 750 000 м². Підбірка поточних та завершених об'єктів.",
  "projects.filter.category": "Категорія:",
  "projects.filter.status": "Статус:",
  "projects.filter.all": "Усі",
  "projects.filter.villa": "Вілли",
  "projects.filter.einfamilienhaus": "Одноквартирні будинки",
  "projects.filter.reihenhaus": "Рядні будинки",
  "projects.filter.stadthaus": "Таунхауси",
  "projects.filter.wohnbau": "Квартири",
  "projects.filter.sanierung": "Реновація",
  "projects.filter.infrastruktur": "Інфраструктура",
  "projects.empty": "Проєктів не знайдено.",
  "projects.loading": "Завантаження проєктів…",
  "projects.card.details": "Детальніше",
  "projects.card.energy_class": "Клас A+++",
  "projects.card.certified": "Сертифіковано за ÖNORM · klimaaktiv",

  "project.about_eyebrow": "Про проєкт",
  "project.video_eyebrow": "Відео проєкту",
  "project.video_title": "Локація у кадрі.",
  "project.video_lede": "Кінематографічний огляд локації, архітектури та кварталу — зйомка на місці.",
  "project.about_title": "Архітектура та концепція",
  "project.highlights": "Переваги",
  "project.floorplans": "Плани поверхів",
  "project.energy_certificate": "Енергетичний сертифікат",
  "project.energy_certificate_download": "Завантажити енергетичний сертифікат",
  "chat.button_label": "Задати питання",
  "chat.title": "Асистент Royal House",
  "chat.subtitle": "Питання про наші проєкти",
  "chat.placeholder": "Ваше питання…",
  "chat.send": "Надіслати",
  "chat.greeting": "Доброго дня! Готовий відповісти на питання про наші проєкти у Відні, Штирії, Зальцбурзі та Україні. Як я можу допомогти?",
  "chat.error": "Асистент тимчасово недоступний. Спробуйте пізніше або скористайтеся формою зв'язку.",
  "chat.close": "Закрити",
  "chat.thinking": "Друкує…",
  "chat.suggestion_1": "Які проєкти є у Відні?",
  "chat.suggestion_2": "Як з вами зв'язатися?",
  "chat.suggestion_3": "Чим відрізняється Royal House?",



  "project.specs": "Ключові дані",
  "project.cta_inquire": "Надіслати запит",
  "project.not_found": "Проєкт не знайдено.",

  "about.eyebrow": "Про нас",
  "about.title.l1": "Досконалість,",
  "about.title.l2": "якій можна",
  "about.title.l2_em": "довіряти.",
  "about.lede":
    "Royal House Bauträger GmbH зі штаб-квартирою у Відні проєктує та реалізує житлові об'єкти у верхньому сегменті. Ми поєднуємо класичний досвід забудовника з BIM-проєктуванням, точною префабрикацією та міжнародною партнерською мережею. Інженерні системи — наш партнер ECO Building Technik.",
  "about.values.eyebrow": "Наші цінності",
  "about.team.eyebrow": "Керівництво та партнери",
  "about.team.title.l1": "Люди, які беруть",
  "about.team.title.l2": "відповідальність.",
  "about.architects.eyebrow": "Топ-архітектори · Альянс",
  "about.architects.title.l1": "Міжнародні топ-архітектори",
  "about.architects.title.l2": "в нашому альянсі.",
  "about.partners.eyebrow": "Компанії-партнери",
  "about.partners.title": "Наша мережа.",
  "about.cta.title.l1": "Давайте",
  "about.cta.title.l2": "збудуємо разом.",
  "about.cta.title.l2_em": "",

  "contact.eyebrow": "Контакти",
  "contact.title.l1": "Поговоримо",
  "contact.title.l2": "про ваш",
  "contact.title.l2_em": "дім.",
  "contact.lede":
    "Запишіться на зустріч або запитайте деталі — наш відділ продажів відповість протягом 24 годин.",
  "contact.form.eyebrow": "Надіслати запит",
  "contact.form.title": "Записатись на зустріч",
  "contact.wellbeing.eyebrow": "Здорове житло · Технологічний партнер",
  "contact.wellbeing.title": "Well-Being ConTech.",
  "contact.wellbeing.body": "Здорове й енергоефективне житло безпосередньо втілюється в наших проєктах — від низькоемісійних матеріалів до розумного дому.",
  "contact.wellbeing.cta_partner": "На сторінку партнера",
  "contact.wellbeing.cta_external": "wellbeingcontech.com",
  "contact.form.first_name": "Ім'я *",
  "contact.form.last_name": "Прізвище *",
  "contact.form.email": "E-mail *",
  "contact.form.phone": "Телефон",
  "contact.form.residence_size": "Площа квартири",
  "contact.form.price_range": "Діапазон цін",
  "contact.form.message": "Повідомлення",
  "contact.form.message_placeholder": "Ваші побажання, запитання або зручна дата",
  "contact.form.privacy_note":
    "Надсилаючи форму, ви погоджуєтеся з нашою політикою конфіденційності. Дані використовуються лише для обробки запиту.",
  "contact.success.title": "Дякуємо!",
  "contact.success.body":
    "Запит отримано. Відділ продажів зв'яжеться з вами протягом 24 годин.",
  "contact.success.new": "Надіслати новий запит →",
  "contact.error.required": "Будь ласка, заповніть ім'я, прізвище та e-mail.",
  "contact.error.generic": "Не вдалося надіслати запит.",
  "contact.success.toast": "Дякуємо! Ми скоро зв'яжемося.",

  "admin.login.eyebrow": "Адміністрування",
  "admin.login.title": "Вхід",
  "admin.login.email": "E-mail",
  "admin.login.password": "Пароль",
  "admin.login.submit": "Увійти",
  "admin.login.submitting": "Вхід…",
  "admin.login.welcome": "З поверненням.",
  "admin.login.failed": "Помилка входу.",
  "admin.dash.eyebrow": "Адмін · Панель",
  "admin.dash.title": "Запити",
  "admin.dash.signed_as": "Ви увійшли як",
  "admin.dash.refresh": "Оновити",
  "admin.dash.logout": "Вийти",
  "admin.dash.empty": "Запитів поки немає.",
  "admin.dash.loading": "Завантаження запитів…",
  "admin.dash.stat_total": "Усього",
  "admin.dash.stat_week": "За тиждень",
  "admin.dash.stat_today": "Сьогодні",
  "admin.dash.stat_phone": "З телефоном",
  "admin.dash.col_name": "Ім'я",
  "admin.dash.col_email": "E-mail",
  "admin.dash.col_size": "Квартира",
  "admin.dash.col_date": "Дата",
  "admin.dash.col_action": "Дія",
  "admin.dash.detail_eyebrow": "Деталі запиту",
  "admin.dash.detail_phone": "Телефон",
  "admin.dash.detail_size": "Площа",
  "admin.dash.detail_price": "Бюджет",
  "admin.dash.detail_received": "Отримано",
  "admin.dash.detail_message": "Повідомлення",
  "admin.dash.confirm_delete": "Видалити запит?",
  "admin.dash.deleted": "Запит видалено.",
  "admin.dash.delete_failed": "Не вдалося видалити.",
  "admin.dash.load_failed": "Не вдалося завантажити запити.",
  "admin.dash.empty_select": "Виберіть запит, щоб побачити деталі.",
  "admin.tabs.inquiries": "Запити",
  "admin.tabs.projects": "Проєкти",
  "admin.tabs.security": "Безпека",
  "admin.sec.title": "Змінити пароль",
  "admin.sec.desc": "Змініть пароль адміністратора. Після зміни вас буде автоматично вийдено із системи, і потрібно буде увійти знову.",
  "admin.sec.current": "Поточний пароль",
  "admin.sec.new": "Новий пароль",
  "admin.sec.confirm": "Підтвердьте новий пароль",
  "admin.sec.hint": "Щонайменше 12 символів.",
  "admin.sec.submit": "Змінити пароль",
  "admin.sec.saving": "Змінення…",
  "admin.sec.success": "Пароль змінено. Будь ласка, увійдіть знову.",
  "admin.sec.min": "Новий пароль має містити щонайменше 12 символів.",
  "admin.sec.mismatch": "Нові паролі не збігаються.",
  "admin.sec.failed": "Не вдалося змінити пароль.",
  "admin.projects.title": "Керування проєктами",
  "admin.projects.new": "Новий проєкт",
  "admin.projects.edit": "Редагувати",
  "admin.projects.delete": "Видалити",
  "admin.projects.confirm_delete": "Дійсно видалити проєкт?",
  "admin.projects.deleted": "Проєкт видалено.",
  "admin.projects.delete_failed": "Видалення не вдалося.",
  "admin.projects.load_failed": "Не вдалося завантажити проєкти.",
  "admin.projects.save_success": "Проєкт збережено.",
  "admin.projects.save_failed": "Збереження не вдалося.",
  "admin.projects.col_title": "Назва",
  "admin.projects.col_location": "Локація",
  "admin.projects.col_status": "Статус",
  "admin.projects.col_year": "Рік",
  "admin.projects.col_category": "Категорія",
  "admin.projects.col_translations": "Переклади",
  "admin.projects.col_action": "Дія",
  "admin.projects.empty": "Ще немає проєктів.",
  "admin.projects.form_title_create": "Створити новий проєкт",
  "admin.projects.form_title_edit": "Редагувати проєкт",
  "admin.projects.field_title": "Назва",
  "admin.projects.field_slug": "Slug (URL)",
  "admin.projects.field_location": "Локація",
  "admin.projects.field_status": "Статус",
  "admin.projects.field_year": "Рік",
  "admin.projects.field_category": "Категорія",
  "admin.projects.field_short_description": "Короткий опис",
  "admin.projects.field_description": "Опис",
  "admin.projects.field_cover_image": "Титульне зображення (URL)",
  "admin.projects.field_images": "Додаткові зображення (URL)",
  "admin.projects.field_video_url": "URL відео (необов'язково)",
  "admin.projects.field_highlights": "Переваги",
  "admin.projects.field_specs": "Характеристики (ключ/значення)",
  "admin.projects.field_floorplans": "Плани поверхів (PDF-посилання)",
  "admin.projects.field_energy_certificate": "Енергетичний сертифікат (PDF)",
  "admin.projects.add_item": "Додати",
  "admin.projects.cancel": "Скасувати",
  "admin.projects.save": "Зберегти",
  "admin.projects.saving": "Збереження…",
  "admin.projects.spec_key_placeholder": "Позначення",
  "admin.projects.spec_value_placeholder": "Значення",
  "admin.projects.floorplan_label_placeholder": "Позначення (напр. перший поверх)",
  "admin.projects.floorplan_url_placeholder": "URL PDF",
  "admin.projects.image_url_placeholder": "URL зображення",
  "admin.projects.highlight_placeholder": "Текст переваги",
  "admin.projects.upload_file": "Завантажити файл",
  "admin.projects.upload_success": "Файл завантажено.",
  "admin.projects.upload_failed": "Завантаження не вдалося.",
  "admin.projects.alt_text_label": "AI-пропозиція alt-тексту",

  "admin.projects.suggest_button": "AI-пропозиція",
  "admin.projects.suggest_success": "Пропозицію застосовано.",
  "admin.projects.suggest_failed": "AI-пропозиція не вдалася.",
  "admin.projects.suggest_needs_title_location": "Спочатку заповніть назву та локацію.",
  "admin.projects.translate_button": "Автопереклад",
  "admin.projects.translate_success": "Переклади застосовано.",
  "admin.projects.translate_failed": "Переклад не вдався.",
  "admin.projects.translate_needs_de": "Спочатку заповніть німецький короткий опис та опис.",
  "admin.projects.translate_hint": "Німецька — основна мова. Натисніть «Автопереклад», щоб заповнити EN/RU/UK.",





  "budova.eyebrow": "Технологічний партнер",
  "budova.title.l1": "Екосистема",
  "budova.title.l2": "Budova.",
  "budova.lede":
    "З 1990 року Budova — один із провідних забудовників півдня України. Понад 30 житлових комплексів, 1 000 000 м² готового житла та дім для більш ніж 30 000 сімей. Budova — технологічна основа нашої префабрикації та BIM-ERP.",
  "budova.stat.years": "Років досвіду (з 1990)",
  "budova.stat.complexes": "Житлових комплексів",
  "budova.stat.sqm": "м² побудовано",
  "budova.stat.families": "Сімей облаштовано",
  "budova.stat.pace": "Поверхів будується на місяць",
  "budova.story.eyebrow": "Історія",
  "budova.story.title": "30 років індустріального будівництва.",
  "budova.story.body":
    "Budova — одна з найбільших будівельних компаній півдня України, лідер житлового будівництва в Одесі. За 30 років компанія заслужила довіру тисяч сімей та здала понад 60 об'єктів — більше половини з них житлові комплекси.",
  "budova.system.eyebrow": "Екосистема",
  "budova.system.title.l1": "BIM-ERP.",
  "budova.system.title.l2": "Індустріальна префабрикація.",
  "budova.system.title.l3": "Унікальне маркування деталей.",
  "budova.cta": "Детальніше на budova.ua",

  "imprint.eyebrow": "Реквізити",
  "imprint.title": "Постачальник та відповідальна особа.",
  "privacy.eyebrow": "Конфіденційність",
  "privacy.title": "Ваші дані · ваш контроль.",

  "lang.label": "Мова",
};

export const TRANSLATIONS = { de, en, ru, uk };
export const LANGUAGES = [
  { code: "de", label: "DE" },
  { code: "en", label: "EN" },
  { code: "ru", label: "RU" },
  { code: "uk", label: "UA" },
];
